import React from 'react';
import './shared.css';

const PrimaryButton = ({ children, onClick, disabled, className = '', small, ...props }) => (
  <button 
    className={`primary-btn ${small ? 'small' : ''} ${className}`}
    onClick={onClick}
    disabled={disabled}
    {...props}
  >
    {children}
  </button>
);

export default PrimaryButton;
